import { usePortalSessionStore } from "@/features/portal/store/portal-session-store";
import { OnboardingStatusLanding } from "./onboarding-status-landing";

/**
 * `/portal/onboarding/done` — thank-you landing after a completed submission
 * (also the destination for an already-completed token). Firm branding, if the
 * shell already resolved it, is shown for context.
 */
export function OnboardingDone() {
  const branding = usePortalSessionStore((s) => s.branding);
  return <OnboardingStatusLanding variant="thankyou" branding={branding} />;
}
